import type { PropsWithChildren } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link, LinkProps } from "react-router-dom";

import { Button } from "components";
import theme from "theme";

const useStyles = makeStyles(theme => ({
  dashboardButton: {
    width: "100%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    "&:hover": {
      backgroundColor: theme.custom.palette.purple.lightest,
      borderColor: theme.custom.palette.purple.main,
      color: theme.custom.palette.purple.main,
    },
  },
}));

type DashboardButtonProps = Pick<LinkProps, "to">;

const DashboardButton = ({
  children,
  to,
}: PropsWithChildren<DashboardButtonProps>) => {
  const classes = useStyles(theme);

  return (
    <Button
      size="large"
      className={classes.dashboardButton}
      variant="text"
      component={Link}
      to={to}
    >
      <Typography
        variant="body1"
        style={{
          fontSize: "0.8rem",
        }}
      >
        {children}
      </Typography>
    </Button>
  );
};

export default DashboardButton;
